import React, { useState, useEffect, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setStep, setOtpVerified } from '../store/reducers/flowStepReducer';
import ProfileForm from '../components/Customer/ProfileForm';
import OtpScreen from '../components/Customer/OtpScreen';
import { useNavigate } from 'react-router-dom';
import { checkCustomer,setProfileFormData,verifyUser } from '../store/reducers/profileReducer';
import { OtpVerify } from '../store/reducers/otpReducer';
import { isEncrypted, parseMobileParamsNew } from './../utils/Common.js';
import { fetchRenewalData } from './../store/reducers/myPlansReducer';
import { showAlert } from './../store/reducers/alertReducer';

const Profile = () => {

  const dispatch = useDispatch();
  const {step, otpVerified} = useSelector((state) => state.flowStepList);
  const {id, userId} = useSelector((state) => state.myPlanList.renewalData);
  const {response} = useSelector((state) => state.myPlanList);
  const profileResponse = useSelector((state) => state.profileList);
  const profileData = profileResponse?.profileData || {};
  const [formMobile, setFormMobile] = useState('');
  const navigate = useNavigate();

  let mobileNumber = profileResponse?.profileData?.data?.mobile ?? '';
  if(mobileNumber.length === 0){
      mobileNumber = profileResponse?.formData?.mobile ?? '';
  }

  useEffect(() => {
    if(id && userId){
      let requestParam = {subscription_id:id,user_id:userId};
      dispatch(fetchRenewalData(requestParam));
    }
  }, [dispatch]);

  const mergedProfileData = useMemo(() => {
    const baseProfile = profileResponse?.profileData?.data || {};
    const renewal = response?.data || {};
  
    const mergedData = {
      ...baseProfile,
      ...renewal, // renewal data overrides base profile
    };
  
    return {
      ...profileResponse,
      profileData: {
        ...profileResponse?.profileData,
        data: mergedData,
      },
    };
  }, [profileResponse, response]);
  


  const handleFormSubmit = async (data) => {
      console.log("profileResponseprofileResponseprofileResponsehandleFormSubmit",profileResponse);
      console.log("mobileNumbermobileNumber",mobileNumber);
      dispatch(setProfileFormData(data));
      setFormMobile(data.mobile);
      
      let source = JSON.parse(localStorage.getItem('src') || '""');
      console.log("srcsourcesourcesource",source);
      if(source === 'cholaone'){
        dispatch(setStep('otp'));
      }else{
        if (!mobileNumber && profileResponse.isNewCustomer && !otpVerified && source !== 'cholaone') {
          dispatch(setStep('otp'));
        } else {
          dispatch(setStep('summary'));
          navigate('/summary'); // Navigate to summary route
        }
    }

  };

  const handleOtpSubmit = async (requestData) => {
    try {
  
      const response = await dispatch(
        OtpVerify(requestData)
      ).unwrap();
  
      if (response?.success) {
  
        dispatch(setOtpVerified(true));
  
        if (mobileNumber) {
  
          const verifiedData = isEncrypted(
            JSON.parse(localStorage.getItem('mblnbr'))
          );
  
          // Wait for token generation
          const tokenResponse = await dispatch(
            verifyUser(verifiedData)
          ).unwrap();
  
          console.log("tokenResponse", tokenResponse);
  
          // Now token exists in localStorage
          const customerResponse = await dispatch(
            checkCustomer(verifiedData)
          ).unwrap();
  
          console.log("customerResponse", customerResponse);
        }
  
        dispatch(setStep('summary'));
        navigate('/summary');
      }
  
    } catch (error) {
  
      console.error(error);
  
      dispatch(
        showAlert({
          type: 'error',
          message: error?.message || 'OTP validation failed'
        })
      );
    }
  };

  console.log("mergedProfileData",mergedProfileData);
  return (
    <div className="profile-details">
      {step === 'form' && <ProfileForm 
                            profile={mergedProfileData} 
                            onSubmit={handleFormSubmit} 
                            renewalData={response?.data} 
                          />
      }
      {step === 'otp' && <OtpScreen mobile={mobileNumber || formMobile} onSubmit={handleOtpSubmit} />}
    </div>
  );
};

export default Profile;
